import { Component, ContentChildren, forwardRef, QueryList } from "@angular/core";
import { COMPONENT_DEFINITION_REF } from "../../utility/component-definition-token";
import { CompositePartComponent } from "../composite-part/composite-part.component";
import { MetricDetailComponent } from "../metric/metric-detail.component";
import { PropertyComponent } from "../property/property.component";

@Component({
    selector: 'thing-selection-dialog',
    template: '',
    providers: [{ provide: COMPONENT_DEFINITION_REF, useExisting: forwardRef(() => ThingSelectionDialogComponent) }]
})
export class ThingSelectionDialogComponent {

    @ContentChildren(PropertyComponent) columnComponents: QueryList<MetricDetailComponent | CompositePartComponent | PropertyComponent>;

}